<div id="background-img-login"></div>
<div class="card login-zone-size mx-auto">
	<article class="card-body">
		<h3 class="card-title text-center mb-3">
			<a
				role="button"
				href="https://www.isycare-technology.com"
				target="_blank"
				rel="noopener noreferrer"
			>
				<img
					id="logo-isycare"
					src="assets/img/logoIsycareTechnology.png"
					alt="Isycare Technology Logo"
					class="mb-3"
				/>
			</a>
			Inscription Prescripteur
		</h3>
		<form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
			<div class="mb-3">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text theme-main-color"
							><i class="bi bi-person-fill"></i
						></span>
					</div>
					<input
						type="text"
						class="form-control"
						name="fullName"
						formControlName="fullName"
						placeholder="Nom complet"
						required
					/>
				</div>
			</div>

			<div class="mb-3">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text theme-main-color"
							><i class="bi bi-envelope-fill"></i
						></span>
					</div>
					<input
						type="email"
						class="form-control"
						name="email"
						formControlName="email"
						placeholder="Adresse email"
						required
					/>
				</div>
			</div>

			<div class="mb-3">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text theme-main-color"
							><i class="bi bi-telephone-fill"></i
						></span>
					</div>
					<input
						type="tel"
						class="form-control"
						name="phone"
						formControlName="phone"
						placeholder="Numéro de téléphone"
						required
					/>
				</div>
			</div>

			<!-- <re-captcha
				(resolved)="resolved(token)"
				(error)="onError($event)"
				errorMode="handled"
				[siteKey]="siteKey"
			></re-captcha> -->

			<div class="d-flex flex-column flex-md-row mx-1">
				<button
					class="btn theme-red-button mt-3 mb-3 mb-md-0 me-3"
					routerLink="/login"
				>
					Annuler
				</button>
				<button
					type="submit"
					class="btn theme-main-color-button btn-block mt-3"
					[disabled]="!signupForm.valid"
					style="flex-grow: 1"
				>
					S'inscrire
				</button>
			</div>

			<div *ngIf="errorMessage" class="alert alert-danger">
				{{ errorMessage }}
			</div>

			<div *ngIf="successMessage" class="alert alert-success">
				{{ successMessage }}
			</div>

			<!-- Texte informatif sur l'email d'activation -->
			<p class="text-muted text-center mt-3">
				Un e-mail d'activation vous sera envoyé pour vérifier votre compte. Vous
				devrez activer votre compte pour accéder au module de prise de
				rendez-vous.
			</p>
		</form>
	</article>
</div>
